import CloseIcon from '@mui/icons-material/Close';
import { Checkbox, FormControlLabel, FormGroup, Modal, Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { DataType } from '../types/General';

interface AddRoleModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  permissions: DataType[];
  setPermissions: Dispatch<SetStateAction<DataType[]>>;
  roleName: string;
  setRoleName: Dispatch<SetStateAction<string>>;
  handleSubmit: () => void;
}

export default function AddNewRole({
  open,
  onClose,
  setOpen,
  permissions,
  setPermissions,
  roleName,
  setRoleName,
  handleSubmit,
}: AddRoleModalProps) {
  const navigate = useNavigate();
  // const [rolename, setRoleName] = useState("");
  const [error, setError] = useState(false);
  useEffect(() => {
    if (open) {
      setPermissions((data) =>
        data.map((prev) => ({
          ...prev,
          isAdd: false,
          isView: false,
          isEdit: false,
          isDelete: false,
        }))
      );
      setError(false);
    }
  }, [open]);
  const handlePermissionChange = (sidebarId: number, permissionType: keyof DataType) => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((permission) => {
        if (permission.sideBarId === sidebarId) {
          const updatedPermission = {
            ...permission,
            [permissionType]: !permission[permissionType],
          };

          // If can_view is false, set can_add_edit and can_be_delete to false
          if (permissionType === 'isView' && !updatedPermission.isView) {
            updatedPermission.isAdd = false;
            updatedPermission.isEdit = false;
            updatedPermission.isDelete = false;
          }

          // If can_add_edit or can_be_delete is true, set can_view to true
          if (updatedPermission.isAdd || updatedPermission.isEdit || updatedPermission.isDelete) {
            updatedPermission.isView = true;
          }

          return updatedPermission;
        }
        return permission;
      })
    );
  };

  return (
    <Modal
      className="modal addRole_modal"
      id="addRoleModal"
      aria-labelledby="addRole-modal-title"
      aria-describedby="addRole-modal-description"
      open={open}
      onClose={() => {
        setError(false);
        onClose();
      }}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>Add New Role</h2>
            <p>Here you can add a new role</p>
          </div>
          <form action="">
            <div className="control_group">
              <TextField
                variant="outlined"
                placeholder="Role name"
                fullWidth
                hiddenLabel
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
              />
              {error && roleName === '' ? <h6 className="err_msg">Role name is required</h6> : ''}
            </div>
            <h3>Roles permission</h3>

            <ul className="roles_list">
              {/* <li>
                <p>Administrator access</p>
                <FormGroup>
                  <FormControlLabel control={<Checkbox />} label="Select all" />
                </FormGroup>
              </li> */}
              {Array.isArray(permissions)
                ? permissions?.map((permission) => (
                    <li key={permission?.sideBarId}>
                      <p>{permission?.label}</p>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox />}
                          label="View"
                          checked={permission?.isView}
                          onChange={() => handlePermissionChange(permission?.sideBarId, 'isView')}
                        />
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Add"
                          checked={permission?.isAdd}
                          onChange={() => handlePermissionChange(permission?.sideBarId, 'isAdd')}
                        />
                        {/* <FormControlLabel
                      control={<Checkbox />}
                      label="Edit"
                      checked={permission?.isEdit}
                      onChange={() =>
                        handlePermissionChange(permission?.sideBarId, "isEdit")
                      }
                    /> */}
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Delete"
                          checked={permission?.isDelete}
                          onChange={() => handlePermissionChange(permission?.sideBarId, 'isDelete')}
                        />
                      </FormGroup>
                    </li>
                  ))
                : 'No Persmission Exists'}
            </ul>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_highlight"
                onClick={() => {
                  setOpen(false);
                  setError(false);
                }}
              >
                Discard
              </Button>
              <Button
                className="btn btn_secondary"
                onClick={() => {
                  setError(true);
                  handleSubmit();

                  navigate('/user-management/roles');
                }}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
